import naja from "naja";
import bootstrap from "@/controls/bootstrap";

class TimeSheetExtension {
    initialize(naja) {
        window.addEventListener('DOMContentLoaded', this.load.bind(this));
        naja.addEventListener('complete', this.initRules.bind(this));

        Nette.validators.timeNotInIntervals = function (elem, args, value) {
            const form = elem.form;
            if (!form) {
                return true;
            }
            const from = form.elements['from']?.value;
            const to = form.elements['to']?.value;

            if (!from || !to || from >= to) {
                return true;
            }

            for (const interval of args) {
                if (from < interval.end && to > interval.start) {
                    return false;
                }
            }
            return true;
        };

        Nette.validators.timeGreaterThan = function (elem, args, value) {
            const fromInput = document.querySelector(`[name="${args.start}"]`);
            const fromValue = fromInput?.value;
            const toValue = value;

            if (fromValue && toValue) {
                return fromValue < toValue;
            }

            return true;
        };
    }

    addRule(el, rule) {
        // Safely parse the existing rules or initialize as an empty array
        let existing = [];
        try {
            existing = JSON.parse(el.dataset.netteRules || '[]');
        } catch (error) {
            console.error('Invalid netteRules JSON:', el.dataset.netteRules, error);
        }

        // Add the new rule to the array
        existing.push(rule);

        // Update the dataset with the new rules
        el.dataset.netteRules = JSON.stringify(existing);
    }

    initRules(form) {
        const el = document.getElementById('frm-tabs-tabContent-vykazyprace-tabControl-eventForm-eventForm');
        let events = JSON.parse($(el).attr('data-events') || '[]');

        if (!(Array.isArray(events) && events.length > 0)) {
            return; // Exit if no events to validate against
        }

        const edit = el.querySelector('[name="edit"]');
        const editId = parseInt(edit.value, 10); // Get the ID to edit and convert to an integer
        events = events.filter(event => event.id !== editId);
        if (events.length <= 0) {
            return;
        }

        const start = el.querySelector('[name="from"]');
        const end = el.querySelector('[name="to"]');

        // Construct the rule as an object
        const rule = {
            op: ':timeNotInIntervals',
            msg: 'Čas se překrývá s jinou událostí',
            arg: events,
        };

        // The rule validates the whole interval — attach to one field only
        // to avoid showing the same error twice.
        this.addRule(start, rule);

        const netteRules = JSON.parse(end.dataset.netteRules || '[]');
        netteRules.push({
            op: ':timeGreaterThan',
            msg: 'Čas "Do" musí být větší než čas "Od".',
            arg: { start: 'from' }, // Name of the "from" field
        });
        end.dataset.netteRules = JSON.stringify(netteRules);

        start.addEventListener('change', () => {
            Nette.validateControl(end);
        });
        end.addEventListener('change', () => {
            // "from" carries the overlap rule that depends on "to"
            Nette.validateControl(start);
        });
    }

    load()
    {
        $(document).on('click', 'a.scroll-to', function(e){
            e.preventDefault();
            const targetId = this.getAttribute('href').replace('#', '');
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
        $(document).on('click', 'a.scroll-top', function(e){
            e.preventDefault();
            $('.app-body').animate({ scrollTop: 0 }, 'fast');
        });
        $(document).on('change', '#snippet-tabs-tabContent-vykazyprace-tabControl-modal input[name=ticket]', function() {
            const caption = $(this).parent().find('.iframe-input-caption').html();
            $(this).closest('form').find('input[name=event]').val(caption);
        });

        $(document).on('change', '#snippet-tabs-tabContent-vykazyprace-tabControl-modal select[name=category]', function() {
            const selectedOption = $(this).find(':selected');
            const from = $(this).closest('form').find('input[name=from]');
            const to = $(this).closest('form').find('input[name=to]');
            const event = $(this).closest('form').find('input[name=event]');

            if (from.val().length <= 0) {
                from.val(selectedOption.data('start')).change();
            }
            if (to.val().length <= 0) {
                const predefinedStart = selectedOption.data('start');
                const predefinedEnd = selectedOption.data('end');
                const fromVal = from.val();

                if (fromVal && predefinedStart && predefinedEnd) {
                    const [startH, startM] = predefinedStart.split(':').map(Number);
                    const [endH, endM] = predefinedEnd.split(':').map(Number);
                    const durationMinutes = (endH * 60 + endM) - (startH * 60 + startM);
                    const [fromH, fromM] = fromVal.split(':').map(Number);
                    const toTotalMinutes = fromH * 60 + fromM + durationMinutes;
                    const toH = Math.floor(toTotalMinutes / 60);
                    const toM = toTotalMinutes % 60;
                    to.val(`${String(toH).padStart(2, '0')}:${String(toM).padStart(2, '0')}`).change();
                } else {
                    to.val(predefinedEnd).change();
                }
            }
            if (event.val().length <= 0) {
                event.val(selectedOption.html().trim()).change().focus();
            }
        });

        $('#snippet-tabs-tabContent-vykazyprace-tabControl-modal').on('shown.bs.modal', function () {
            const from = $(this).find('input[name=from]');
            const to = $(this).find('input[name=to]');
            
            if(from.val().length <= 0) {
                from.focus();
            } else {
                to.focus();
            } 
        });
    }
}

export default TimeSheetExtension;
